<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header collapsedHeight="100px" expandedHeight="100px">
      <div class="productPrices">
        <div class="priceContent">
          <label class="priceContent__label">Origin</label>
          <div class="input-group mb-3 priceContent__inputContainer">
            <select class="custom-select priceContent__input" [(ngModel)]="price.Origin" id="inputGroupSelect01">
              <option>Choose...</option>
              <option *ngFor="let origin of origins" [value]="origin">{{origin}}</option>
            </select>
          </div>
        </div>
        <div class="priceContent">
          <label class="priceContent__label">Price</label>
          <div class="input-group mb-3 priceContent__inputContainer">

            <input [(ngModel)]="price.Price" type="number" step="0.01" class="form-control priceContent__input"
              aria-label="Amount">
          </div>
        </div>

        <div class="priceContent">
          <label class="priceContent__label">Price Ceiling</label>
          <div class="input-group mb-3 priceContent__inputContainer">

            <input [(ngModel)]="price.PriceCeiling" type="number" step="0.01" class="form-control priceContent__input"
              aria-label="Amount">
          </div>
        </div>

        <div class="priceContent">
          <label class="priceContent__label">Discount</label>
          <div class="input-group mb-3 priceContent__inputContainer">

            <input [(ngModel)]="price.Discount" type="number" step="0.01" class="form-control priceContent__input"
              aria-label="Discount">
          </div>
        </div>

        <div class="priceContent">
          <label class="priceContent__label">NUC Points</label>
          <div class="input-group mb-3 priceContent__inputContainer">
            <input [(ngModel)]="price.Points" type="number" step="0.01" class="form-control priceContent__input"
              aria-label="Points">
          </div>
        </div>

        <div class="priceContent">
          <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" [(ngModel)]="price.AllowSetPrice" id="customSwitch{{price.ProductPriceId}}">
            <label class="custom-control-label" for="customSwitch{{price.ProductPriceId}}">Allow Set Price</label>
          </div>
        </div>

        <div class="prodcutPrices__buttonContainer">
          <button type="button" class="btn btn-primary productPrices__saveButton mr-2" (click)="saveProductPrice(price)">
            <span>Save</span>
          </button>
          <button type="button" class="btn btn-danger productPrices__saveButton" (click)="deleteProductPrice(price)">
            <span>Delete</span>
          </button>
        </div>
      </div>
    </mat-expansion-panel-header>

    <app-adjustment-price-form (refresh)="refreshProductView()" [price]="price" [product]="product">
    </app-adjustment-price-form>
  </mat-expansion-panel>
</mat-accordion>